{
  "ingestionSettings": {
    "defaultStandards": {
      "description": "Choisissez les standards par défaut pour vos produits",
      "title": "Standards par défaut"
    },
    "description": "Configurez les paramètres d'ingestion de vos produits",
    "title": "",
    "traceabilityMethod": {
      "description": "Méthode",
      "options": {
        "default": {
          "description": "Tracer vos produits par code, couleur et collection",
          "title": "Traçabilité par défault"
        },
        "multisourcing": {
          "description": "Tracer vos produits par fournisseurs",
          "title": "Traçabilité par multisourcing"
        },
        "traceabilityByPo": {
          "description": "Tracer vos produits par bon de commande",
          "title": "Traçabilité par bon de commande"
        }
      },
      "title": "Traçabilité"
    },
    "update": {
      "error": "An error occurred while updating the ingestion settings",
      "success": "Ingestion settings updated successfully"
    }
  },
  "inviteUsers": {
    "error": "Une erreur est survenue lors de l'invitation des utilisateurs",
    "success": "Utilisateurs invités avec succès"
  },
  "mapping": {
    "create": "Créer",
    "mapping": "",
    "material": "Matériaux",
    "pageDescription": "Cette page vous permet d'associer vos catégories de produits, vos types de matériaux et vos standards avec les éléments de référence correspondants dans la plateforme.",
    "pending_one": "1 élément n'a pas de correspondance.",
    "pending_many": "{{ count }} éléments n'ont pas de correspondance.",
    "pending_other": "{{ count }} éléments n'ont pas de correspondance.",
    "product": "Catégories de produit",
    "search": "Rechercher",
    "standards": "Standards",
    "success": "Le référentiel a été mis à jour.",
    "title": ""
  },
  "supplierSettings": {
    "addNewSupplier": "Nouveau partenaire commercial",
    "addSupplier": "Sauvegarder",
    "cancel": "Annuler",
    "deleteSupplier": {
      "cancel": "Annuler",
      "confirm": "Supprimer",
      "error": "Erreur lors de la suppression du partenaire commercial",
      "message": "Voulez-vous vraiment supprimer le partenaire commercial sélectionné ? Cette action est irrévocable.",
      "success": {
        "message": "Partenaire commercial supprimé avec succès",
        "title": "Partenaire commercial supprimé"
      },
      "title": "Confirmation"
    },
    "dropdownButton": {
      "label": "Actions"
    },
    "importSuppliers": "Importer des partenaires commerciaux",
    "invalidEmail": "Email invalide",
    "productionSites": {
      "noProductionSitesLabel": "Aucun",
      "productionOperations": "Opérations de production",
      "title": "Sites associés"
    },
    "searchSuppliers": "Rechercher",
    "submit": "Créer",
    "supplierEmail": "Email du partenaire commercial",
    "title": "Partenaire commercial"
  }
}
